const tables = document.querySelectorAll(".table>.viewmore,.table>.spviewmore");

if (tables.length) {
    tables.forEach((vm) => {
        const parent = vm.parentNode;
        let oHeight = parent.getBoundingClientRect().height;
        // let hidePercent = vm.dataset.hideSp ? Number(vm.dataset.hideSp) : 0.79;

        let closeHeight = (370 / 390) * 100;

        // console.log(parent, oHeight, closeHeight);

        if (innerWidth <= 1024) {
            parent.style.height = `${closeHeight}vw`;
        }

        vm.addEventListener("click", () => {
            parent.classList.add("clicked");
            parent.style.height = `${(oHeight / 390) * 100}vw`;
            setTimeout(() => {
                parent.style.height = ``;
            }, 200);
        });
    });
}
